var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFavoriteBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.937 4.86182C19.857 2.76182 16.0537 3.74182 14.0003 6.14515C11.947 3.74182 8.14366 2.75015 5.06366 4.86182C3.43033 5.98182 2.40366 7.87182 2.33366 9.86682C2.17033 14.3935 6.18366 18.0218 12.3087 23.5868L12.4253 23.6918C13.312 24.4968 14.677 24.4968 15.5637 23.6802L15.692 23.5635C21.817 18.0102 25.8187 14.3818 25.667 9.85515C25.597 7.87182 24.5703 5.98182 22.937 4.86182ZM14.117 21.8485L14.0003 21.9652L13.8837 21.8485C8.33033 16.8202 4.667 13.4952 4.667 10.1235C4.667 7.79015 6.417 6.04015 8.75033 6.04015C10.547 6.04015 12.297 7.19515 12.9153 8.79349H15.097C15.7037 7.19515 17.4537 6.04015 19.2503 6.04015C21.5837 6.04015 23.3337 7.79015 23.3337 10.1235C23.3337 13.4952 19.6703 16.8202 14.117 21.8485Z",
    fill: "#484D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavoriteBorder);
export default __webpack_public_path__ + "static/media/icon_favorite_border.8cd2030ae5b8cc4ec488ce67d1ece2f3.svg";
export { ForwardRef as ReactComponent };